import { useQuery } from '@tanstack/react-query';

import { fetchVersion, type BuildInfo } from './api';

/**
 * The deployed build's git SHA + build time (any authenticated user).
 * A running build's identity never changes, so we fetch once and never refetch.
 */
export function useVersion() {
  return useQuery<BuildInfo>({
    queryKey: ['version'],
    queryFn: fetchVersion,
    staleTime: Infinity,
    retry: false,
  });
}
